<template>
  <v-app id="inspire">
    <drawer
      id="drawer"
      :show-fin-session="showFinSession"
      @title="setTitle"
    />
    <loader id="loader" />
    <alert id="alert" />

    <toolbar
      ref="toolbar"
      :title="title"
      :cashier-name="cashierName"
    />

    <v-main id="vcontent">
      <v-container fluid>
        <v-row>
          <v-col
            cols="12"
            md="6"
            offset-md="3"
            lg="4"
            offset-lg="4"
          >
            <router-view
              ref="router"
              @title="setTitle"
              @show-products="showProductKeyboard = true"
              @hide-products="showProductKeyboard = false"
              @set-brightness="setBrightness"
              @set-vibration="setVibration"
              @send-transactions="sendTransactions"
              @change-env="changeEnv"
            />
            <product-keyboard
              v-if="useProductKeyboard"
              v-show="showProductKeyboard"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <div id="printer" />
  </v-app>
</template>

<script>
import Drawer from './components/core/Drawer'
import Loader from './components/core/Loader'
import Alert from './components/core/Alert'
import Toolbar from './components/core/Toolbar'

import ProductKeyboard from './components/keyboard/product/ProductKeyboard'
import { getTimeRemaining, startRemoteSettings, startRemoteSettingsScheduler } from '@/modules/Utils'
import { MetierLocalStorage } from 'modulelocalstorage'
import {EnumModeCashiers} from '@/modules/Enums';

export default {
  name: 'App',

  components: {
    Drawer,
    Loader,
    Alert,
    Toolbar,
    ProductKeyboard
  },

  data () {
    return {
      title: '',
      showProductKeyboard: false
    }
  },

  computed: {
    useProductKeyboard () {
      return this.$store.getters.productslength > 0
    },
    cashierName() {
      const {teleparameters} = this.$store.state;
      const connectedCashier = MetierLocalStorage.getConnectedCashier();

      if (!teleparameters || !connectedCashier) return null;

      const {CashierEngagementMode, Cashiers} = teleparameters;

      return (CashierEngagementMode === EnumModeCashiers.SESSION || CashierEngagementMode === EnumModeCashiers.FLOATING) && Cashiers.length > 0
        ? connectedCashier.name
        : null;
    },
    showFinSession() {
      return !!this.cashierName;
    }
  },

  created () {
    // Options
    this.$store.commit('usenfc', localStorage.getItem('usenfc') !== 'false')
    this.$store.commit('usemanscan', localStorage.getItem('usemanscan') !== 'false')
    let useQrcodeDefault = localStorage.getItem('useqrcodes') !== 'false'

    if (IS_DESKTOP) {
      useQrcodeDefault = localStorage.getItem('useqrcodes') === 'true'
    } else if (IS_ANDROID) {
      // Gestion des tickets bancaire
      this.$store.commit('manageBankingTickets', localStorage.getItem('manageBankingTickets') === 'true')
      this.$store.commit('printCustomerTicket', localStorage.getItem('printCustomerTicket') === 'true')
      this.$store.commit('printMerchantTicket', localStorage.getItem('printMerchantTicket') === 'true')

      // Détermination de l'utilisation de la vibration
      this.$store.commit('usevibrate', localStorage.getItem('usevibrate') === 'true')

      // Détermination de l'utilisation de l'assombrissement
      this.$store.commit('usebrightness', localStorage.getItem('usebrightness') === 'true')
      this.$store.commit('keepscreenon', localStorage.getItem('keepscreenon') === 'true')

      // // Ecoute du nombre de transactions restantes en attente (from cashless plugin)
      // Cashless.addTransactionListener((nb) => {
      //   this.$store.commit('nbTransactions', nb.count)
      //   this.$store.commit('totalTransactions', nb.ca)
      // })
    }
    this.$store.commit('useqrcodes', useQrcodeDefault)
  },

  mounted () {
    // Une fois l'application montée, on retire le splash
    document.getElementsByTagName('html')[0].classList.remove('splash')

    if (!IS_DESKTOP) {
      const btPrinter = MetierLocalStorage.getPrinter()
      if (IS_PAX) {
        CissAndroid.setMacPrinter(btPrinter ? btPrinter.mac : null)
      } else {
        screen.orientation.lock(MetierLocalStorage.getScreenOrientation())
      }
      if (IS_ANDROID) {
        // Récupération imprimante bluetooth favorite
        this.$store.commit('printer', btPrinter)
        // Contrôle réveil forcé par programmation
        SchedulerPlugin.load((forceReload) => {
          if (forceReload === 1) {
            SchedulerPlugin.stop()
            startRemoteSettings(true)
          } else if (
            MetierLocalStorage.getTeleparametres() !== null &&
            MetierLocalStorage.getRemoteSettingsAuto().used
          ) {
            startRemoteSettingsScheduler(getTimeRemaining())
          }
        })
        // Dissimulation des barres d'état après 200ms
        setTimeout(() => {
          AndroidFullScreen.immersiveMode()
        }, 200)
      }
    }

    if (navigator.splashscreen) {
      setTimeout(() => {
        // Coupure du splash à la création de l'application
        navigator.splashscreen.hide()
      }, 200)
    }
  },

  methods: {
    setTitle (title) {
      this.title = title
    },
    setBrightness (use) {
      if (use) {
        this.$refs.toolbar.startBrightnessListener()
      } else {
        this.$refs.toolbar.stopBrightnessListener()
      }
    },
    setVibration (use) {
      if (use) {
        this.$refs.toolbar.startVibrationListener()
      } else {
        this.$refs.toolbar.stopVibrationListener()
      }
    },
    sendTransactions () {
      setTimeout(_ => {
        this.$refs.toolbar.sendTransactions()
      }, 1000)
    },
    changeEnv (env) {
      this.$refs.toolbar.changeEnv(env)
    }
  }
}
</script>

<style lang="scss">
@supports(padding:max(0px)) {
  body, header, footer {
    padding-left: min(0vmin, env(safe-area-inset-left));
    padding-right: min(0vmin, env(safe-area-inset-right));
  }
}

// - 5 px est la pour initialiser la vue sans scroll
body{
  height: calc(100dvh - env(safe-area-inset-bottom) - 5px);
  overflow: hidden;
}

.v-main{
  max-height: calc(100dvh - env(safe-area-inset-bottom) - 10px);
  overflow: hidden;
}

html{
  background-color: #8e9090;
}

.toolbar, #drawer, #vcontent > .v-main__wrap, .body-2 {
  margin-top: constant(safe-area-inset-top) !important; /* iOS 11.0 */
  margin-top: env(safe-area-inset-top) !important; /* iOS 11.2 */
}

#drawer{
  max-height: 100dvh;
}

// #footer, .v-application .clavier-action, .pull-bottom, .container.pull-bottom {
//   padding-bottom: constant(safe-area-inset-bottom) !important; /* iOS 11.0 */
//   padding-bottom: env(safe-area-inset-bottom) !important; /* iOS 11.2 */
// }

.theme--light.application, .theme--dark.application {
  background-color: none;
}

.container {
  padding: 0;
  margin: 0;
}

.row, .row > div {
  padding: 0;
  margin: 0;
}
.v-toolbar__extension {
  background-color: #FF5252;
}

.v-text-field__suffix {
  color: red;
}
.v-item-group.theme--dark, .theme--dark.v-card {
  background-color: #424242 !important;
  .v-tab.v-tab--active {
    color: #F0F0F0;
  }
}

.no-underline, .no-underline.v-input--is-focused {
  .v-input__slot:before, .v-input__slot:after {
    border: none !important;
  }
}

#printer {
  display: none;
  max-width:280px;
  padding: 16px;
  margin: 16px;

  pre {
    color: #000000 !important;
  }
}
@media print {
  @page { margin: 0; }
  #printer {
    display: block;
  }
  .toolbar, #vcontent {
    display: none;
  }
}
</style>
